import FeatureLayer from "@arcgis/core/layers/FeatureLayer";


let url =
  "https://services1.arcgis.com/ze0XBzU1FXj94DJq/ArcGIS/rest/services/East_Coast_Shellfish_Hatchery_and_Nursery_Directory_/FeatureServer/0";

export const hatcheriesLayer = new FeatureLayer({
	//url: "https://terrene.njaes.rutgers.edu:6443/arcgis/rest/services/Shellfish/Hatcheries/MapServer/0"
	//url:'https://services1.arcgis.com/ze0XBzU1FXj94DJq/ArcGIS/rest/services/East_Coast_Shellfish_Hatchery_and_Nursery_Directory_/FeatureServer/0'
	url
	, outFields: ['*']
	, popupEnabled: true
	, popupTemplate: {
		outFields: ['*'],
		title: "<strong>{Business_Name} - {State}</strong>",
		content: (target) => {
			console.log('The target: ', target);

			const myFieldInfo = [];
			const FindValues = [
				'Mailing_Address',
				'City',
				'State',
				'Business_Type',
				'CUSTOM_NAME',
				'Primary_Phone',
				'Secondary_Phone',
				'Email_Address',
				'Secondary_Email',
				'Website',
				'Species',
				'Species_Other',
				/*
				'Address',
				'Hatchery',
				'Nursery',
				'Private_Ha',
				'Research',
				'Contact',
				'Phone',
				'Phone_2',
				'FAX',
				'email',
				'email_2',
				'website'
				*/
			];
			if( target.graphic && target.graphic.attributes ){

				FindValues.forEach( (key) => {

					if( key === 'CUSTOM_NAME') {
						myFieldInfo.push({
							label: 'Contact',
							value: `${target.graphic.attributes.First_Name} ${target.graphic.attributes.Last_Name}`
						});
						return;
					}
					const value = target.graphic.attributes[key];

					if( typeof value === 'string' && value.trim() !== '' ) {
						if( key === 'website' ) {
							myFieldInfo.push({
								label: key,
								value: `<a href="${value.startsWith('http') === false ? 'https://' : '' }${value}" target="_blank">${value}</a>`
							});
						}else{
							myFieldInfo.push({
								label: key,
								value
							});
						}
					}else if( typeof value === 'number' ) {
						myFieldInfo.push({
							label: key,
							value: ( value === 1 ? 'Yes' : 'No' )
						});
					}
				});
			}

			return myFieldInfo.map( (item) => {
				return `<p><strong>${item.label}</strong>: ${item.value} </p>`;
			}).join('');



			//return 'ASDF';
			/*
			let fieldInfo2 = new FieldInfo({
				fieldName: "Address",
				label: "Address",
				visible: true
			  });
			  
			  // Create the FieldsContent element
			  let fieldsElement = new FieldsContent({
				fieldInfos: [ fieldInfo2]
			  });
return fieldsElement;
*/
/*
			return {	
				type:'fields',
				outfields:['*'],

				fieldInfos: [
					{fieldName: 'Address'},
					{fieldName: 'Contact'},
					{fieldName: 'Phone'},
					{fieldName: 'email', label:'Email'},
					{fieldName: 'website', label:'Website'}
				]
			}
			*/
		}
		/*[{	
			type:'fields',
			fieldInfos: [
				{fieldName: 'Address'},
				{fieldName: 'Contact'},
				{fieldName: 'Phone'},
				{fieldName: 'email', label:'Email'},
				{fieldName: 'website', label:'Website'}
			]
		}]
		*/
		/*
		content: (target) => {
			console.log('The target: ', target);
			const myFieldInfo = [];
			const FindValues = [
				'Address',
				'Hatchery',
				'Nursery',
				'Private_Ha',
				'Research',
				'Contact',
				'Phone',
				'Phone_2',
				'FAX',
				'email',
				'email_2',
				'website'
			];
			if( target.graphic && target.graphic.attributes ){

				FindValues.forEach( (key) => {
					if( target.graphic.attributes[key] ){
						myFieldInfo.push({
							fieldName: key,
							label: key
						});
					}

				});
				return new Promise( (resolve, reject) => { 
					return resolve({	
						type:'fields',
						fieldInfos: [
							{fieldName: 'Address'}
						]
					});
				}).then( (response) => {
					return response;
				});
			}
			return null;
		}*/
		/*
		[
			(target) => {
				
				return new Promise((resolve, reject) => {
					resolve('test');
				});
			},
			{	
				type:'fields',
				fieldInfos: [
					{fieldName: 'Address'}
				]
			}
		]
		*/
		/* (target) => {
			console.log('The target: ', target);
			return new Promise((resolve, reject) => {
			const myFieldInfo = [];
			const FindValues = [
				'Address',
				'Hatchery',
				'Nursery',
				'Private_Ha',
				'Research',
				'Contact',
				'Phone',
				'Phone_2',
				'FAX',
				'email',
				'email_2',
				'website'
			];
			if( target.graphic && target.graphic.attributes ){

					FindValues.forEach( (key) => {
						if( target.graphic.attributes[key] ){
							myFieldInfo.push({
								fieldName: key,
								label: key
							});
						}

					});
console.log('Resolving: ', myFieldInfo);

				resolve([{
					// It is also possible to set the fieldInfos outside of the content
					// directly in the popupTemplate. If no fieldInfos is specifically set
					// in the content, it defaults to whatever may be set within the popupTemplate.
					type: "fields",
					fieldInfos: myFieldInfo
				}]);
			}else{
				reject('Could not fetch data from the arc server.');
			}
			/*
			State: Florida
			Company: Clamtastic
			Hatchery: 1
			Nursery: 1
			Private_Ha: 0
			Research: 1
			Contact: Chris Topping or Anthony Hinkle
			Address: P.O. Box 664, Cedar Key, FL 32625
			Phone: 352-213-5999
			Phone_2: 352-949-2233
			FAX:
			email: clamtastic2000@yahoo.com
			email_2:
			website: 
			* /
			});
		}
			*/
		/*(target) => {
			console.log('The target: ', target)
			return new Promise(() => { 
				return "<p class=\"no-margin\">{Address} (Promise)</p>"
			}, () => { 
				return "<p class=\"no-margin\">N/A (Promise)</p>"
			})
		}*/ //"<p class=\"no-margin\">{Address}</p>"
	}
});

export const hatcheriesMeta = {
  layerTitle: hatcheriesLayer.title,
  layerDescription:
    "This layer contains all available shellfish hatchery, nursery, and research locations for the east coast.",
  mapService: url,
  authoritiveSource: "",
};
